// =============================================================================
// ServiceLegend - Legenda servizi con colori usati nella giornata
// =============================================================================

import { useMemo } from 'react';
import { getServiceColor } from '../utils/color.utils';
import type { ServiceLegendProps } from '../types/scheduler.types';

export function ServiceLegend({ services, appointments }: ServiceLegendProps) {
  const usedServices = useMemo(() => {
    const usedIds = new Set(appointments.map(a => a.serviceDefinitionId));
    return services.filter(s => usedIds.has(s.id));
  }, [services, appointments]);
  
  if (usedServices.length === 0) return null;
  
  return (
    <div className="flex flex-wrap gap-3 text-xs">
      {usedServices.map(service => (
        <div key={service.id} className="flex items-center gap-1.5">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: getServiceColor(service.id, service.color) }}
          />
          <span className="text-gray-600">{service.name}</span>
        </div>
      ))}
    </div>
  );
}
